import { dataLayer } from 'analytics/data-layer';

export enum SEARCH_TYPE {
  BULK = 'bulk',
  BULK_ON_RESULTS_PAGE = 'bulk_on_results_page',
  REFINED_ON_RESULTS_PAGE = 'refined_search_on_results_page',
}

export enum SEARCH_TERM_TYPE {
  IMAGE = 'image',
  REFINED_TEXT = 'refined text',
  TEXT = 'text',
}

export function trackListSearch({
  multiSearchTermList,
  numberOfResults,
  searchType,
  searchTermType,
  totalNumberOfTerms,
}: {
  multiSearchTermList: string[];
  numberOfResults: number;
  searchType: SEARCH_TYPE;
  searchTermType: SEARCH_TERM_TYPE;
  totalNumberOfTerms: number;
}) {
  dataLayer.push({
    event: 'list_search',
    multi_search_term_list: multiSearchTermList,
    number_of_results: numberOfResults,
    search_type: searchType,
    search_term_type: searchTermType,
    total_number_of_terms: totalNumberOfTerms,
  });
}

export function trackListSearchError({
  searchType,
  searchTermType,
}: {
  searchType: SEARCH_TYPE;
  searchTermType: SEARCH_TERM_TYPE;
}) {
  dataLayer.push({
    event: 'list_search_error',
    search_type: searchType,
    search_term_type: searchTermType,
  });
}

export function trackListSearchResults({
  searchTerm,
  numberOfResults,
  searchTermType,
}: {
  searchTerm: string;
  numberOfResults: number;
  searchTermType: SEARCH_TERM_TYPE;
}) {
  dataLayer.push({
    event: 'list_search_results',
    search_term: searchTerm,
    number_of_results: numberOfResults,
    search_term_type: searchTermType,
  });
}

export function trackListSearchSelect({
  index,
  itemId,
  itemName,
  numberOfResults,
  searchTerm,
  searchTermType,
}: {
  index: number;
  itemId: string;
  itemName: string;
  numberOfResults: number;
  searchTerm: string;
  searchTermType: SEARCH_TERM_TYPE;
}) {
  dataLayer.push({
    event: 'list_search_select',
    search_term: searchTerm,
    number_of_results: numberOfResults,
    search_term_type: searchTermType,
    item_id: itemId,
    item_name: itemName,
    index,
  });
}

export function trackListSearchDeselect({
  index,
  itemId,
  itemName,
  numberOfResults,
  searchTerm,
  searchTermType,
}: {
  index: number;
  itemId: string;
  itemName: string;
  numberOfResults: number;
  searchTerm: string;
  searchTermType: SEARCH_TERM_TYPE;
}) {
  dataLayer.push({
    event: 'list_search_deselect',
    search_term: searchTerm,
    number_of_results: numberOfResults,
    search_term_type: searchTermType,
    item_id: itemId,
    item_name: itemName,
    index,
  });
}
